<template>
  <div class="activity_box">
    模板二
  </div>
</template>
<script>
import activityApi from "@/api/apis/activity.js";
export default {
  name: "activityTemplate",
  props: {

  },
  data() {
    return {
      activityInfo: null, //活动详情
    };
  },
  components: {

  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },


  },
  created() {

  },
};
</script>
<style scoped lang="scss">
.activity_box {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>